import React from "react";

interface ExternalLinkIconProps {
  width?: number;
  height?: number;
  className?: string;
  fill?: string;
}

export const ExternalLinkIcon: React.FC<ExternalLinkIconProps> = ({
  width = 16,
  height = 16,
  className = "",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.73535 4L7.28711 5.53809H4.05469C3.6549 5.53813 3.33109 5.88285 3.33105 6.30762V11.6924C3.33109 12.1172 3.6549 12.4619 4.05469 12.4619H9.12305C9.52269 12.4617 9.84664 12.117 9.84668 11.6924V8.25781L11.2949 6.71973V11.6924C11.2949 12.9667 10.3224 13.9998 9.12305 14H4.05469C2.85521 14 1.88285 12.9669 1.88281 11.6924V6.30762C1.88285 5.03318 2.85521 4.00004 4.05469 4H8.73535ZM13.7266 2C13.9431 2 14.1191 2.16789 14.1191 2.375V5.59473C14.1191 5.92879 13.6963 6.0956 13.4492 5.85938L12.3203 4.78027L6.0459 10.7803C5.7396 11.0731 5.24282 11.0731 4.93652 10.7803C4.63043 10.4874 4.63042 10.0126 4.93652 9.71973L11.2109 3.71973L10.082 2.64062C9.83504 2.40445 10.0102 2.00022 10.3594 2H13.7266Z"
        fill="currentColor"
      />
    </svg>
  );
};
